import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Shield, ShieldCheck, ShieldOff } from 'lucide-react';

const PERMISSION_CATEGORIES = {
  orders: { label: 'Orders & Dispatches', icon: Shield },
  batches: { label: 'Batches & QC', icon: Shield },
  products: { label: 'Products & Customers', icon: Shield },
  labels: { label: 'Labels', icon: Shield },
  reports: { label: 'Reports & Export', icon: Shield },
  accounts: { label: 'Accounts & Invoicing', icon: Shield },
  admin: { label: 'Admin & Settings', icon: Shield },
};

export function RolesPermissionsCard({ systemPermissions, permissionCategories }) {
  return (
    <Card data-testid="roles-permissions-card">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Shield className="w-4 h-4" />
          Roles & Permissions
        </CardTitle>
        <CardDescription>
          What each role can access. Built-in roles cannot be edited. Create custom roles for fine-grained control.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b bg-muted/50">
                <th className="text-left px-3 py-2 text-xs font-medium uppercase text-muted-foreground w-[200px]">Permission</th>
                <th className="text-center px-3 py-2 text-xs font-medium uppercase text-muted-foreground">Super Admin</th>
                <th className="text-center px-3 py-2 text-xs font-medium uppercase text-muted-foreground">Admin</th>
                <th className="text-center px-3 py-2 text-xs font-medium uppercase text-muted-foreground">User</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {Object.entries(PERMISSION_CATEGORIES).map(([catKey, cat]) => (
                <React.Fragment key={catKey}>
                  <tr className="bg-muted/20">
                    <td colSpan={4} className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-1.5">
                      <cat.icon className="w-3.5 h-3.5" />{cat.label}
                    </td>
                  </tr>
                  {(permissionCategories[catKey] || []).map(perm => (
                    <tr key={perm} className="hover:bg-muted/10">
                      <td className="px-3 py-2 text-xs">{systemPermissions[perm] || perm}</td>
                      <td className="text-center px-3 py-2"><ShieldCheck className="w-4 h-4 text-emerald-500 mx-auto" /></td>
                      <td className="text-center px-3 py-2">
                        {perm.includes('backup') || perm.includes('restore') ?
                          <ShieldOff className="w-4 h-4 text-rose-400 mx-auto" /> :
                          <ShieldCheck className="w-4 h-4 text-emerald-500 mx-auto" />
                        }
                      </td>
                      <td className="text-center px-3 py-2"><ShieldOff className="w-4 h-4 text-slate-300 mx-auto" /></td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        <p className="text-xs text-muted-foreground mt-3">
          Users with the "User" role need permissions explicitly granted via the Edit User dialog.
        </p>
      </CardContent>
    </Card>
  );
}
